export enum ConfigurationActions {
  CREATE = "create_configuration",
  UPDATE = "update_configuration",
  GET = "get_configuration",
  GET_ALL = "get_configurations",
  DELETE = "delete_configuration"
}